import React, { forwardRef } from 'react';
import get from 'lodash.get';

import {
  CheckboxContainer,
  StyledCheckboxWrapper,
  StyledLabelContainer,
  HiddenCheckbox,
  StyledCheckboxIcon,
  StyledCheckboxLabel,
  Icon,
  Error,
} from './styles';

const Checkbox = forwardRef(({ className, name, defaultChecked, label, onChange, onBlur, errors }, ref) => {
  const error = get(errors, name, false);
  return (
    <StyledCheckboxWrapper className={className}>
      <CheckboxContainer>
        <HiddenCheckbox
          id={name}
          type="checkbox"
          name={name}
          defaultChecked={defaultChecked}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
        />
        <StyledCheckboxIcon className="styled-checkbox">
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckboxIcon>
      </CheckboxContainer>
      <StyledLabelContainer>
        <StyledCheckboxLabel>{label}</StyledCheckboxLabel>
        {!!error && <Error>{error?.message || 'Required'}</Error>}
      </StyledLabelContainer>
    </StyledCheckboxWrapper>
  );
});
export default Checkbox;
